import { sendSaveGeneratedQuestionsEvent } from '../index';
import { EventAdapter } from './EventAdapter';

interface SaveGeneratedQuestionsEventAdapterParams {
  numQuestionsGenerated: number;
  numQuestionsSelected: number;
  source: SaveGeneratedQuestionsEventSource;
  saveAction: SaveGeneratedQuestionsEventSaveAction;
  numTf: number;
  numMc: number;
  numSa: number;
}

export class SaveGeneratedQuestionsEventAdapter extends EventAdapter {
  protected amplitudeEventFunction = sendSaveGeneratedQuestionsEvent;
  protected intercomEventKey = null;

  constructor({
    numQuestionsGenerated,
    numQuestionsSelected,
    source,
    saveAction,
    numTf,
    numMc,
    numSa,
  }: SaveGeneratedQuestionsEventAdapterParams) {
    super();

    try {
      this.eventData = {
        num_questions_generated: numQuestionsGenerated,
        num_questions_selected: numQuestionsSelected,
        source: source,
        save_action: saveAction,
        num_tf: numTf,
        num_mc: numMc,
        num_sa: numSa,
      };
    } catch (err) {
      console.error('Error parsing analytics data', err);
    }
  }
}

/** What generated the questions that are being saved. */
export type SaveGeneratedQuestionsEventSource =
  | 'areas_of_improvement'
  | 'specific_student';

/** The action the user took with the generated questions. */
export type SaveGeneratedQuestionsEventSaveAction = 'save' | 'save_edit';

export type SaveGeneratedQuestionsEvent = {
  /** The total number of questions generated. */
  num_questions_generated: number;
  /** The number of questions selected by the user. */
  num_questions_selected: number;
  /** The number of true false questions generated. */
  num_tf: number;
  /** The number of multiple choice questions generated. */
  num_mc: number;
  /** The number of short answer questions generated. */
  num_sa: number;
  /** What generated the questions that are being saved. */
  source: SaveGeneratedQuestionsEventSource;
  /** The action the user took with the generated questions. */
  save_action: SaveGeneratedQuestionsEventSaveAction;
};
